export async function getReportEmbedInfo(
  role: string,
  groupId: string,
  reportId: string,
  datasetId: string
) {
  const url =
    process.env.REACT_APP_POWERBI_API +
    `/power-bi/embed-info?role=${role}&groupId=${groupId}&reportId=${reportId}&datasetId=${datasetId}`;

  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer emcp9movo05IETBCCmTv6kE_nf4WGCUFZfsNo_ttodQ",
    },
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`获取嵌入信息失败: ${errorText}`);
  }
  return await response.json();
}
